import {FRMain} from "#Formulas/FormulaCore";
import {FormDataRetriever} from "#Formulas/FormulaCore/FormDataRetriever";
declare var jQuery:any;
export class FormulaCalculator{
    public Parser:FRMain;
    public Form:HTMLDivElement;
    public FormId:number;
    public FieldId:number;

    public ShouldFormatAsNumber:boolean;
    public Prefix:string;
    public Suffix:string;
    public Decimals:string;
    public ThousandSeparator:string;
    public DecimalSeparator:string;
    constructor(public Field:HTMLDivElement,public Formula:any) {
        this.Parser=new FRMain(this.Formula.Compiled,new FormDataRetriever(this.Field));
        this.Form=this.Field.closest('form.wpforms-form') as HTMLDivElement;

        this.FormId=this.Form.getAttribute('data-formid') as any;
        this.FieldId=this.Field.getAttribute('data-field-id') as any;

        let input=this.Field.querySelector('input');

        if(input.getAttribute('data-should-format-number')=='1')
        {
            this.ShouldFormatAsNumber=true;
            this.Prefix=input.getAttribute('data-prefix') as any;
            this.Suffix=input.getAttribute('data-suffix') as any;
            this.Decimals=input.getAttribute('data-decimals') as any;
            this.ThousandSeparator=input.getAttribute('data-thousand-separator') as any;
            this.DecimalSeparator=input.getAttribute('data-decimal-separator') as any;
        }
    }

    public Initialize(){
        for(let fieldId of this.Formula.FieldsUsed)
        {
            document.querySelectorAll('.wpforms-field[data-field-id="'+fieldId+'"] input,.wpforms-field[data-field-id="'+fieldId+'"] select,.wpforms-field[data-field-id="'+fieldId+'"] textarea').forEach(element=>{
                element.addEventListener('change',()=>{
                    this.Calculate();
                });
            });
        }

        jQuery(document).on('wpformsProcessConditionalsField',(e, formid,fieldId)=>{

            if(this.FormId!=formid)
                return;

            if(this.Formula.FieldsUsed.some(x=>x==fieldId))
                this.Calculate();
        })

        this.Calculate();
    }

    private Calculate() {
        let value=this.Parser.Parse();
        if(this.ShouldFormatAsNumber)
        {
            value=this.Format(value);
        }

        this.Field.querySelector('input').value=value;
    }

    private Format(amount: any) {
        if(amount=='')
            return '';
        amount=parseFloat(amount);
        if(isNaN(amount))
            amount=0;

        let text=amount.toFixed(this.Decimals);
        var x = text.split('.');
        var x1 = x[0];
        var x2 = x.length > 1 ? '.' + x[1] : '';
        var rgx = /(\d+)(\d{3})/;
        if(this.ThousandSeparator!='') {
            while (rgx.test(x1)) {
                x1 = x1.replace(rgx, '$1' + this.ThousandSeparator + '$2');
            }
        }

        if(x2.length>0)
        {
            x2=x2.slice(1);
            x2=this.DecimalSeparator+x2;
        }
        text= x1 + x2;

        return this.Prefix+text+this.Suffix;
    }
}